<template>
  <v-app>
    <v-main>
      <v-container fluid>
        <v-card outlined max-height="800px" class="rounded-xl">
          <v-card-title>
            <h6 class="text-sm-h4 text-h6 mx-auto">
              Подача заявлений на оценку ЭУК
            </h6>
          </v-card-title>
        </v-card>
        <v-row class="mt-4 fill-height">
          <v-col cols="12" class="d-flex">
            <v-row class="full-height">
              <v-col cols="12" md="4" class="d-flex">
                <CardStatusesCommission/>
              </v-col>
              <v-col cols="12" md="8" class="d-flex">
                <CardCommentsCommission/>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="d-flex">
            <CardFillingTechnologicalMap/>
          </v-col>
        </v-row>
        <v-snackbar
            max-width="400px"
            :value="status_snackbar"
            @input="setStatusSnackbar"
            :timeout="5000"
            rounded="xl"
            right
            top
            color="teal"
            outlined
        >
          <v-list-item>
            <v-list-item-icon>
              <v-icon
                  color="teal"
                  left
              >
                fa-exclamation-circle
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="teal--text text-h6">
                Технологическая карта создана!
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-snackbar>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import {mapActions, mapState, mapMutations} from "vuex";
import CardStatusesCommission from "./Cards/CardStatusesCommission";
import CardCommentsCommission from "./Cards/CardCommentsCommission";
import CardFillingTechnologicalMap from "./Cards/CardFillingTechnologicalMap";

export default {
  name: "DashboardEstimationEuk",
  components: {
    CardStatusesCommission,
    CardCommentsCommission,
    CardFillingTechnologicalMap
  },
  data: () => ({}),
  destroyed() {
    this.resetStudyEstEukTechMapCommissionStore()
    this.resetStadyEstimationEukStore()
    this.resetStudyEstEukTechMapStore()
    this.resetStudyEstEukTechMapAdditDataStore()
  },
  mounted() {

  },
  computed: {
    ...mapState({
      response: state => state.studyEstEukTechMap.response,
      status_snackbar: state => state.studyEstEukTechMap.status_snackbar,
    }),
    message() {
      return this.response?.data?.message
    }
  },
  methods: {
    ...mapActions({

    }),
    ...mapMutations({
      resetStudyEstEukTechMapStore: 'studyEstEukTechMap/resetStudyEstEukTechMapStore',
      resetStadyEstimationEukStore: 'studyEstimationEuk/resetStadyEstimationEukStore',
      resetStudyEstEukTechMapAdditDataStore: 'studyEstEukTechMapAdditData/resetStudyEstEukTechMapAdditDataStore',
      resetStudyEstEukTechMapCommissionStore: 'studyEstEukTechMapCommission/resetStudyEstEukTechMapCommissionStore',
      setStatusSnackbar: 'studyEstEukTechMap/setStatusSnackbar',
    })
  }

}
</script>

<style scoped>

</style>